const localStorageUtils = {
  setObject: (key, value) => {
    try {
      window.localStorage.setItem(key, JSON.stringify(value))
    } catch (error) {
      console.warn('localStorageUtils @ setObject >>>>>', error)
    }
  },

  delete: key => {
    window.localStorage.removeItem(key)
  },

  getObject: key => {
    const value = window.localStorage.getItem(key)
    return value && JSON.parse(value)
  },
}

export default localStorageUtils
